import { render, staticRenderFns } from "./PurchaseReceipt.vue?vue&type=template&id=51870f00&scoped=true"
import script from "./PurchaseReceipt.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseReceipt.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseReceipt.vue?vue&type=style&index=0&id=51870f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51870f00",
  null
  
)

export default component.exports